import { memo, useCallback } from 'react';

import { Error } from '../error';
import { Loading } from '../loading';
import { type TRemoteProps } from './types';

export const Remote = memo((props: TRemoteProps) => {
  const { status, children, className } = props;

  const Component = children;

  const renderContent = useCallback(() => {
    switch (status) {
      case 'success':
        return <div className={className}>{Component}</div>;
      case 'error':
        return <Error error={{ message: 'Что-то пошло не так' }} />;
      case false:
        return <div className={className}>{Component}</div>;
      default:
        return <Loading visible />;
    }
  }, [status, className, Component]);

  return <>{renderContent()}</>;
});
